function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useMemo, useEffect } from "react";
import BaseTemplate from "components/templates/base-template";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import TemplatesNavigation from "template-store/components/navigation/navigation-component";
import MainPageContent from "template-store/components/main-page-content/main-page-content";
import { filterSolutions, getSolution } from "template-store/services/solutions-service";
import { HOME_ID } from "template-store/constants/categories";
import { getSolutionName, getSolutionEnglishName, SOLUTION_TO_CANONICAL_URL_MAPPING } from "template-store/services/solution-data-service";
import { getSolutionPageLink, getSolutionSearchLink } from "template-store/services/solution-links-service";
import { SOLUTION_STORE_SEARCH } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { SOLUTIONS_IN_CATEGORY_PAGE_TYPE, SOLUTIONS_HOME_PAGE_TYPE, SINGLE_SOLUTION_PAGE_TYPE } from "constants/template-center/solution-page-types";
import { StyledSolutionPageLayoutComponent } from "./solution-page-layout-component.scss";
const SEARCH_TERM_MIN_LENGTH_FOR_BIGBRAIN_EVENT = 3;
const SolutionPageLayoutComponent = (props)=>{
    const { pageType, allSolutions, allCategories, categoryId, solutionId, searchTermFromAdressBar, tabsMetadata } = props, baseTemplateProps = _object_without_properties(props, [
        "pageType",
        "allSolutions",
        "allCategories",
        "categoryId",
        "solutionId",
        "searchTermFromAdressBar",
        "tabsMetadata"
    ]);
    const [searchTerm, setsearchTerm] = useState("");
    const [filteredSolutions, setFilteredSolutions] = useState([]);
    const handleSearchTermChange = useCallback((term)=>{
        const solutions = filterSolutions(allSolutions, term);
        setsearchTerm(term);
        setFilteredSolutions(solutions);
        if (term.length >= SEARCH_TERM_MIN_LENGTH_FOR_BIGBRAIN_EVENT) trackEvent(SOLUTION_STORE_SEARCH, {
            kind: term,
            info1: solutions === null || solutions === void 0 ? void 0 : solutions.length
        });
        history.replaceState({}, "", getSolutionSearchLink(term));
    }, [
        allSolutions
    ]);
    useEffect(()=>{
        if (searchTermFromAdressBar) {
            handleSearchTermChange(searchTermFromAdressBar);
        }
    }, []);
    const selectedCategoryId = useMemo(()=>{
        if (pageType === SOLUTIONS_IN_CATEGORY_PAGE_TYPE) return categoryId;
        if (pageType === SOLUTIONS_HOME_PAGE_TYPE) return HOME_ID;
        return null;
    }, [
        categoryId,
        pageType
    ]);
    const pageMetaTitle = useMemo(()=>{
        switch(pageType){
            case SOLUTIONS_IN_CATEGORY_PAGE_TYPE:
                return `templateCenter.${categoryId}.meta.title`;
            case SINGLE_SOLUTION_PAGE_TYPE:
                const solution = getSolution(allSolutions, solutionId);
                const solutionName = getSolutionName(solution);
                return {
                    key: "templateCenter.specificTemplate.meta.title",
                    param: solutionName
                };
            default:
                return "templateCenter.meta.title";
        }
    }, [
        categoryId,
        solutionId,
        pageType,
        allSolutions
    ]);
    const canonicalUrl = useMemo(()=>{
        if (pageType !== SINGLE_SOLUTION_PAGE_TYPE) return null;
        if (SOLUTION_TO_CANONICAL_URL_MAPPING[solutionId]) {
            return SOLUTION_TO_CANONICAL_URL_MAPPING[solutionId];
        }
        const solution = getSolution(allSolutions, solutionId);
        const solutionEnglishName = getSolutionEnglishName(solution);
        return getSolutionPageLink(solutionId, solutionEnglishName);
    }, [
        allSolutions,
        pageType,
        solutionId
    ]);
    return /*#__PURE__*/ _jsx(BaseTemplate, _object_spread_props(_object_spread({}, baseTemplateProps), {
        title: pageMetaTitle,
        description: "templateCenter.meta.description",
        enableHotjar: "true",
        canonicalUrl: canonicalUrl,
        children: /*#__PURE__*/ _jsxs(StyledSolutionPageLayoutComponent, {
            className: "solution-page-component",
            children: [
                /*#__PURE__*/ _jsx(BaseHeaderComponent, {}),
                /*#__PURE__*/ _jsxs("div", {
                    className: "template-page-content",
                    children: [
                        /*#__PURE__*/ _jsx("nav", {
                            className: "desktop-navigation-wrapper",
                            "aria-label": "Template categories",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "navigation-sticky-wrapper",
                                children: /*#__PURE__*/ _jsx(TemplatesNavigation, {
                                    onSearchChange: handleSearchTermChange,
                                    searchTerm: searchTerm,
                                    allCategories: allCategories,
                                    selectedCategoryId: selectedCategoryId
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("main", {
                            className: "page-main-content",
                            children: /*#__PURE__*/ _jsx(MainPageContent, {
                                pageType: pageType,
                                allSolutions: allSolutions,
                                allCategories: allCategories,
                                categoryId: categoryId,
                                solutionId: solutionId,
                                searchTerm: searchTerm,
                                filteredSolutions: filteredSolutions,
                                tabsMetadata: tabsMetadata,
                                selectedCategoryId: selectedCategoryId,
                                onSearchChange: handleSearchTermChange
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(LongFooterComponent, {})
            ]
        })
    }));
};
export default SolutionPageLayoutComponent;
